export default __webpack_public_path__ + "static/media/arrow-back.fa014d0c.svg";